<div fxFlex fxLayout="column">
  <mmx-timeslot-recommendation
    *ngIf="nextRecommendedTimeSlot$ | async as recommended"
    [timeSlot]="recommended"
    [disabled]="(timeSlotsRemaining$ | async) === 0 || options?.readonly === true"
    icon="thumb_up"
    [label]="'time-slot-picker.recommended.label' | translate"
    class="recommended-time-slot"
    (add)="onAdd($event)"
  ></mmx-timeslot-recommendation>

  <mmx-timeslot-recommendation
    *ngIf="soonestTimeSlot$ | async as soonestTimeSlot"
    [timeSlot]="soonestTimeSlot"
    [disabled]="(timeSlotsRemaining$ | async) === 0 || options?.readonly === true"
    icon="sunny"
    [label]="'time-slot-picker.soonest.label' | translate"
    (add)="onAdd($event)"
  ></mmx-timeslot-recommendation>

  <ng-container *ngIf="hasAvailableSlots$ | async; else noTimesEl">
    <mmx-time-slot-picker-custom
      *ngIf="!!options"
      [timeSlots]="options.availableTimes.timeSlots || []"
      [selectedTimeSlots]="selectedTimeSlots$ | async"
      [dateRange]="options.dateRange"
      [timezone]="options.timezone"
      [workingDays]="options.workingDays"
      [readonly]="options.readonly"
      (add)="onAdd($event)"
      (remove)="onRemove($event)"
      (dateRangeChange)="dateRangeChange.emit($event)"
    ></mmx-time-slot-picker-custom>

    <div *ngIf="(allSelectedTimeSlots$ | async)?.length" fxLayout="column">
      <div fxFlex fxLayoutAlign="center center" class="subtitle mt-15">
        {{ 'time-slot-picker.selected.title' | translate }}
      </div>

      <div fxLayoutAlign="center center" class="selected-times">
        <mat-chip-listbox
          cdkDropList
          cdkDropListOrientation="horizontal"
          fxLayout="row wrap"
          fxLayout.lt-md="column"
          fxLayoutGap="1em"
          fxLayoutAlign="center center"
        >
          <mat-chip-option
            *ngFor="let date of allSelectedTimeSlots$ | async"
            fxLayoutAlign="space-between center"
            [color]="date.isAvailable ? 'primary' : 'warn'"
            [highlighted]="!date.isAvailable && !!date.time"
            [removable]="!options?.readonly"
            [selectable]="false"
            (removed)="onRemove(date.time)"
          >
            <span>
              {{ date.time.format('ddd MMMM Do h:mm a') }}
              <small *ngIf="!date.isAvailable">
                ({{ 'patient.appointment-reschedule.requested.text-unavailable' | translate }})
              </small>
            </span>
            <button matChipRemove *ngIf="!options?.readonly">
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip-option>
        </mat-chip-listbox>
      </div>
    </div>

    <div
      *ngIf="!options?.readonly"
      fxLayoutAlign="center center"
      class="mt-15"
    >
      <ng-container *ngIf="timeSlotsRequired$ | async as timeSlotsRequired; else timeSlotsRemainingTmpl">
        {{ 'time-slot-picker.selected.required' | translate: { required: timeSlotsRequired } }}
      </ng-container>
      <ng-template #timeSlotsRemainingTmpl>
        <ng-container *ngIf="timeSlotsRemaining$ | async as timeSlotsRemaining">
          {{ 'time-slot-picker.selected.remaining' | translate: { remaining: timeSlotsRemaining } }}
        </ng-container>
      </ng-template>
    </div>
  </ng-container>
</div>

<ng-template #noTimesEl>
  <div *ngIf="!loading" class="no-dates text-center">
    {{ 'time-slot-picker.custom-date.no-dates' | translate }}
  </div>
</ng-template>

<div *ngIf="loading" class="disabled-overlay" fxLayoutAlign="center center">
  <mat-progress-spinner
    mode="indeterminate"
    color="primary"
    diameter="50"
  ></mat-progress-spinner>
</div>

